import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  textField: {
    width: '100%',
  },
  semiBold: {
    fontWeight: 600,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
    maxWidth: '100%',
  },
  title: {
    marginLeft: '0px',
    marginBottom: '0px',
    marginTop: '1rem',
    paddingLeft: '0px',
  },
  loading: {
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
  backButtonQuestionResponse: {
    width: '80px',
    paddingLeft: '0px',
    color: theme.palette.secondary.middleGray,
    '& span': {
      fontSize: '13px',
    },
  },
  table: {
    minWidth: 650,
    width: '100%',
  },
}));

export default useStyles;
